export default __webpack_public_path__ + "static/media/add-person.35fff0fa.svg";